import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=d31deb6a"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d31deb6a')) {
      api.createRecord('d31deb6a', component.options)
    } else {
      api.reload('d31deb6a', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=d31deb6a", function () {
      api.rerender('d31deb6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/Tab.vue"
export default component.exports